exports = module.exports = require("../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".react-clock{display:block;position:relative}.react-clock,.react-clock *,.react-clock :after,.react-clock :before{box-sizing:border-box}.react-clock__face{position:absolute;top:0;bottom:0;left:0;right:0;border:1px solid #000;border-radius:50%}.react-clock__hand{position:absolute;top:0;bottom:0;left:50%;right:50%}.react-clock__hand__body{position:absolute;background-color:#000;transform:translateX(-50%)}.react-clock__mark{position:absolute;top:0;bottom:0;left:50%;right:50%}.react-clock__mark__body{position:absolute;background-color:#000;transform:translateX(-50%)}.react-clock__mark__number{position:absolute;left:-40px;width:80px;text-align:center}.react-clock__second-hand__body{background-color:red}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/react-clock/dist/Clock.css
// module id = 369
// module chunks = 0